import { z } from "zod";
import { compilationSongIdSchema } from "./compilation-song.js";
import { compilationThemeIdSchema, } from "./compilation-theme/compilation-theme.js";
export const compilationOccasionIds = [
    "birthday",
    "wedding",
    "anniversary",
    "retirement",
    "graduation",
    "baby",
    "workplace",
    "teacher",
    "in-memory-of",
    "holiday",
    "other",
];
// If we ever store the themes in a database, we won't be able to strongly type
// the IDs. But for now, we can.
export const compilationOccasionIdSchema = z.enum(compilationOccasionIds);
var Month;
(function (Month) {
    Month[Month["JANUARY"] = 0] = "JANUARY";
    Month[Month["FEBRUARY"] = 1] = "FEBRUARY";
    Month[Month["MARCH"] = 2] = "MARCH";
    Month[Month["APRIL"] = 3] = "APRIL";
    Month[Month["MAY"] = 4] = "MAY";
    Month[Month["JUNE"] = 5] = "JUNE";
    Month[Month["JULY"] = 6] = "JULY";
    Month[Month["AUGUST"] = 7] = "AUGUST";
    Month[Month["SEPTEMBER"] = 8] = "SEPTEMBER";
    Month[Month["OCTOBER"] = 9] = "OCTOBER";
    Month[Month["NOVEMBER"] = 10] = "NOVEMBER";
    Month[Month["DECEMBER"] = 11] = "DECEMBER";
})(Month || (Month = {}));
export const compilationOccasionSchema = z.object({
    version: z.literal(1),
    occasionId: compilationOccasionIdSchema,
    name: z.string(),
    themes: z.array(compilationThemeIdSchema),
    songs: z.array(compilationSongIdSchema),
    /** Determine if an occasion is active based on whether the current date is
     * within that time window */
    activeMonths: z.array(z.enum(Month)).optional(),
});
